export default __webpack_public_path__ + "_/images/beer/therese_von_bayern/beer-vessel-4f2141d122fd90ca64da86f0523f6e2bcb0ec9f36c79d0069e6df65a78deedc8.png";